import BackdropManager from "./BackdropManager";

export default BackdropManager;
export { BackdropManager };
